import { createFileRoute } from '@tanstack/react-router';
import { Box, Text, Flex } from '@chakra-ui/react';
import { useAuth } from '@/features/auth/authContext';

export const Route = createFileRoute('/_authenticated/dashboard/')({
  component: DashboardPage,
});

function DashboardPage() {
  const { user } = useAuth();

  return (
    <Box>
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        ダッシュボード
      </Text>

      <Flex direction="column" gap={4}>
        <Box bg="bg.panel" p={6} borderRadius="lg" shadow="sm">
          <Text fontSize="lg" fontWeight="medium" mb={2}>
            ようこそ、{user?.email} さん
          </Text>
          <Text color="fg.muted" fontSize="sm">
            左メニューから管理機能にアクセスしてください。
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
